import { MONTHLY } from './../components/Common/constants';

export const checkMonthlyPaaymentOption = (chargings) => {
    if(!chargings.length) return false;
    else if(chargings.length > 0) return true;
    // else if (chargings[0].chargingType?.name === MONTHLY) return true;
    else return false;
}